type Direction = 'left' | 'right' | 'top' | 'bottom'
type Props = {
  direction: Direction
  size?: number
}

const Chevron = ({ direction, size }: Props) => {
  const calculateDeg = (direction: Direction) => {
    switch (direction) {
      case 'right':
        return 0;
      case 'left':
        return 180;
      case 'top':
        return 270;
      case 'bottom':
        return 270;
    }
  };

  return (
    <svg style={{ transform: `rotate(${ calculateDeg(direction) }deg)` }} width={size ? size : 20} height={size ? size * 1.6 : 32} viewBox="0 0 20 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.19406e-05 3.66112L12.0364 15.579L9.8568e-06 27.4969L3.70553 31.158L19.4737 15.579L3.70553 6.34714e-05L1.19406e-05 3.66112Z" fill="white"/>
    </svg>
  );
};

export default Chevron;